// web-v2/src/lib/named-insured-address.js
//
// WHAT THE NAMED-INSURED SHEET SAYS ABOUT THE ADDRESS (2026-10-05). An address
// is ONE fact with five pieces (street, street 2, city, state, zip), and the
// accounts writer (account-write-through.js addressFromZohoFields, in the services folder)
// carries it to Supabase only as a whole unit: street, city, a two-letter state
// and zip, or all of them blank to clear. The sheet used to send only the
// pieces the broker touched, so a one-field edit reached Zoho and was recorded
// as "not carried" for Supabase: the half-right record the rule exists to stop.
// Now the whole address rides the save, and a half address does not:
//
//   touched  any piece differs from what the sheet loaded
//     whole       the five pieces are sent
//     all blank   the five (blank) are sent: a deliberate clear
//     partial     NOTHING is sent and Save is blocked, with the reason
//   untouched  the loaded address is whole: the five are sent again, a faithful
//              restatement, so every save of a whole address carries it;
//              the loaded address is blank or itself partial: nothing is sent
//              (there is no whole address to restate; a blank is never sent as
//              a clear the broker did not ask for)
//
// Pure, no imports: the guard runs it in node (tests/named-insured-whole-address.test.js).

export const ADDRESS_PIECES = Object.freeze([
  ['street', 'account_street'], ['street2', 'account_street_2'], ['city', 'account_city'], ['st', 'account_st'], ['zip', 'account_zip'],
]);
export const PARTIAL_ADDRESS_WORDS = 'An address needs street, city, a two-letter state and zip together. Fill the rest, or clear them all.';

const unit = (c) => Object.fromEntries(ADDRESS_PIECES.map(([k]) => [k, String((c && c[k]) == null ? '' : c[k]).trim()]));
export const isWholeAddress = (a) => !!(a.street && a.city && a.zip && /^[A-Za-z]{2}$/.test(a.st));
export const isBlankAddress = (a) => ADDRESS_PIECES.every(([k]) => !a[k]);
const bodyOf = (a) => Object.fromEntries(ADDRESS_PIECES.map(([k, body]) => [body, a[k]]));

/** { body, state } for one save: body is the five account_* keys or {}; state is whole | cleared | restated | partial | untouched. */
export function addressForSave(contact, loaded) {
  const cur = unit(contact); const was = unit(loaded);
  const touched = ADDRESS_PIECES.some(([k]) => cur[k] !== was[k]);
  if (touched) {
    if (isWholeAddress(cur)) return { body: bodyOf(cur), state: 'whole' };
    if (isBlankAddress(cur)) return { body: bodyOf(cur), state: 'cleared' };
    return { body: {}, state: 'partial' };
  }
  return isWholeAddress(was) ? { body: bodyOf(cur), state: 'restated' } : { body: {}, state: 'untouched' };
}
